import React, { useRef, useState, useEffect } from 'react';
import cn from 'classnames';
import style from './carousel.mod.scss';
import Container from '../layout/container/container';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useSliderContext } from '../../context/SliderContext';
import ArrowRight from '../global/icons/arrow-right';
import ArrowLeft from '../global/icons/arrow';
import 'swiper/css';
import 'swiper/css/navigation';
import { GatsbyImage } from 'gatsby-plugin-image';
import Heading from '../heading/heading';
import Text from '../text/text';
import Button from '../button/button';
import { motion } from 'framer-motion';

const Carousel = ({ cards, heading, id }) => {
  const classes = cn(style.carousel);
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const { activeSlide, updateActiveSlider } = useSliderContext();
  const [slideIndex, setSlideIndex] = useState(0);
  const [swiperKey, setSwiperKey] = useState(Date.now());

  useEffect(() => {
    setSlideIndex(activeSlide);
    setSwiperKey(Date.now());
  }, []);

  const contentVariants = {
    offscreen: {
      opacity: 0,
    },
    onscreen: {
      opacity: 1,
      transition: {
        duration: 1,
        delay: 0.2,
      },
    },
  };

  return (
    <Container size="xl">
      <div className={classes}>
      <motion.div
            variants={contentVariants}
            initial="offscreen"
            whileInView="onscreen"
            viewport={{ once: true, amount: 0.1 }}
          >
        <Swiper
          key={swiperKey}
          modules={[Navigation]}
          spaceBetween={24}
          slidesPerView={1.15}
          className={style.carousel__swiper}
          ref={swiperRef}
          grabCursor={true}
          initialSlide={slideIndex}
          navigation={{
            prevEl: `.${id}-prev`,
            nextEl: `.${id}-next`,
          }}
          breakpoints={{
            800: {
              spaceBetween: 32,
              slidesPerView: 2.2,
            },
            1240: {
              spaceBetween: 32,
              slidesPerView: 3.3,
            },
            1400: {
              spaceBetween: 64,
              slidesPerView: 3.3,
            },
          }}
          onSlideChange={(swiper) => {
            setActiveIndex(swiper.realIndex);
            updateActiveSlider(swiper.activeIndex);
          }}
        >
          {cards.map((card, index) => (
            <SwiperSlide key={`swiper-slides-${index}`}>
              <div>
                <Card
                  {...card}
                  index={index}
                  isActive={index === activeIndex + 3}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        </motion.div>
        <div className={style.carousel__navigation}>
          <div className={`${id}-prev`}>
            <ArrowLeft />
          </div>
          <div className={`${id}-next`}>
            <ArrowRight />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Carousel;

const Card = ({ title, cardBlurb, category, date, readTime, isActive, id }) => {
  return (
    <div className={cn(style.card, { [style.card__last]: isActive })}>
      <div className={style.card__category}>
        <div>{category}</div>
      </div>
      <div className={style.card__heading}>
        <Text text={title} size={'xl'} />
      </div>
      <div className={style.card__date}>
        <div>{date}</div>
        <div>|</div>
        <div>{readTime} read</div>
      </div>
      <div className={style.card__text}>
        <Text text={cardBlurb} size="sm" />
      </div>
      <div className={style.card__button}>
        <Button text="Read Musing" pageId={id} />
      </div>
    </div>
  );
};
